export default class Translation {
  constructor(data) {
    if (data && data.fields) {
      const { key, value } = data.fields;
      this.key = key;
      this.value = value;
    }
  }
}
